<div class="form">
    <div class="historyPanel mat-small">
        <div *ngIf="formInstance.createdDate">
            <strong>created</strong> {{ formInstance.createdDate | date: 'MMM d, YYYY, h:mm:ss a' }}
            <span *ngIf="formInstance.createdByUserName"><br />by {{ formInstance.createdByUserName }}</span>
        </div>
        <div *ngIf="formInstance.modifiedDate > formInstance.createdDate">
            <strong>modified</strong> {{ formInstance.modifiedDate | date: 'MMM d, YYYY, h:mm:ss a' }}
            <span *ngIf="formInstance.modifiedByUserName"><br />by {{ formInstance.modifiedByUserName }}</span>
        </div>
    </div>
    <form *ngIf="this.NgFormGroup" matForm [formGroup]="this.NgFormGroup">
        <div *ngIf="formInstance.canEditMetadata" class="control-wrapper">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
                <mat-label>Name</mat-label>
                <input matInput placeholder="Name" formControlName="name" required>
            </mat-form-field>
        </div>
        <div *ngIf="!formInstance.canEditMetadata">
            <div><strong>Name</strong></div>
            <div>
                {{formInstance.name}}
            </div>
        </div>
        <br />
        <div>
            <div><strong>Form Template</strong></div>
            {{formInstance.form.name}}
        </div>
        <br />
        <div>
            <div><strong>Workflow</strong></div>
            {{this.workflowName}}
        </div>
        <br />
        <div>
            <div><strong>Current State</strong></div>
            {{formInstance.currentWorkflowState}}
        </div>

        <!--<div *ngIf="formInstance.canEdit" class="control-wrapper">
        <mat-form-field>
            <mat-label>Workflow</mat-label>
            <mat-select formControlName="workflowId"
                        (selectionChange)="this.workflowSelectionChanged($event.value)">
                <mat-option *ngFor="let wf of this.SiteWorkflows" [value]="wf.id">
                    {{wf.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div *ngIf="this.ShowWorkflowStateControl">
        <div class="control-wrapper">
            <mat-form-field>
                <mat-label>Change Workflow State</mat-label>
                <mat-select (selectionChange)="this.transitionWorkflow($event.value)">
                    <mat-option *ngFor="let wfs of this.WorkflowStateTransitions" [value]="wfs">{{wfs.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>-->

        <div class="button-wrapper">
            <div *ngIf="formInstance.canEditMetadata">
                <button mat-raised-button type="submit" color="primary" class="theme-primary-btn" (click)="onSave()" [disabled]="!(this.NgFormGroup.valid && this.NgFormGroup.dirty)">Save</button>
                <button mat-raised-button (click)="reset()"><span *ngIf="!this.NgFormGroup.dirty">Cancel</span><span *ngIf="this.NgFormGroup.dirty">Reset</span></button>
            </div>
            <div *ngIf="!formInstance.canEditMetadata">
                <button mat-raised-button (click)="onClose()">Close</button>
            </div>
        </div>
    </form>
</div>
